import * as z from "zod/v4";

const trackstarReturnConnectionSettingsInput_ = z.object({
  shouldLookupOrderNameFromTrackstar: z
    .object({ enabled: z.boolean() })
    .optional(),
  shouldIncludeBundleProducts: z.boolean().optional(),
  allowBlindReturns: z.boolean().optional(),
  allowBlindReturnsFallback: z.boolean().optional(),
  disableIncludeTrackingNumber: z.boolean().optional(),
  shouldCreateReturns: z.boolean().optional(),
});

export const trackstarReturnConnectionSettingsInput: z.ZodType<TrackstarReturnConnectionSettingsInput> =
  trackstarReturnConnectionSettingsInput_;
export interface TrackstarReturnConnectionSettingsInput
  extends z.infer<typeof trackstarReturnConnectionSettingsInput_> {}

export const updateTrackstarReturnConnectionSettings = {
  name: "updateTrackstarReturnConnectionSettings" as const,
  input: z.object({
    connectionId: z.string(),
    settings: trackstarReturnConnectionSettingsInput,
  }),
  output: z.object({ success: z.boolean() }),
};
